<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.addEventListener('message', (data) => {
      if (data) {
        if (data.data.type === 'blur') {
          if (!document.hasFocus()) {
            setTimeout(() => {
              parent.postMessage({
                type: 'blur'
              }, '*');
            }, 10)
          } else {
            setTimeout(() => {
              parent.postMessage({
                type: 'focus'
              }, '*');
            }, 10)
          }
        } else if (data.data.type === 'focus') {
          parent.postMessage({
            type: 'focus'
          }, '*')
        } else if (data.data.type === 'keyBlur') {
          parent.postMessage({
            type: 'blur'
          }, '*')
        }
      }
    }, false);
    if (window != top) {
      window.addEventListener("input", () => {
        parent.postMessage({
          type: 'focus'
        }, '*')
      });
      window.addEventListener('focus', (e) => {
        parent.postMessage({
          type: 'focus'
        }, '*')
      });
      window.addEventListener('blur', (e) => {
        parent.postMessage({
          type: 'blur'
        }, '*');
      });
      // 为右键添加自定义事件，可以禁用
      window.oncontextmenu = function () {
        event.preventDefault(); // 阻止默认事件行为
        return false;
      };
      window.document.onkeydown = function (event) {
        event = window.event || event;
        let key = event.keyCode;
        if (((key === 27 || key === 122 || key === 123 || key === 91) || (event.ctrlKey && event.shiftKey && key ===
          46) || (event.altKey && (key !== 78 || !(key > 47 && key < 58))))) {
          parent.postMessage({
            type: 'blur'
          }, '*');
        }
      };
      window.document.onkeyup = function (event) {
        event = window.event || event;
        let key = event.keyCode;
        if (((key === 27 || key === 122 || key === 123 || key === 91) || (event.ctrlKey && event.shiftKey && key ===
          46) || (event.altKey && (key !== 78 || !(key > 47 && key < 58))))) {
          parent.postMessage({
            type: 'blur'
          }, '*');
        }
      };
    }
  },
  beforeMount () {
    if (window.self !== window.top) {
      parent.postMessage({
        type: 'load'
      }, '*');
    }
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
<style lang="scss">
@import url("./assets/css/cover.scss");

:root {
  --btnBgColor: #1890FF;
  /* --btnBgColor: pink; */
}

@import url("./assets/css/skin.scss");

* {
  @include scrollbar_color('scrollbarTrack', 'scrollbarThumb');
}

@import "./assets/css/elStyle.scss";

@import "./assets/css/dialog-drawer-style.scss";

/* 引入阿里图标的样式文件 */
@import url("//at.alicdn.com/t/c/font_4463890_znn9ntjxeem.css");

/* 引入markdown 公式样式 */
//@import url("https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.5.1/katex.min.css");
//@import url("https://cdn.jsdelivr.net/github-markdown-css/2.2.1/github-markdown.css");


.CodeMirror{
  height: 100% !important;
  background: none !important;
}
.CodeMirror .CodeMirror-gutters{
  background: none !important;
}
.CodeMirror .CodeMirror-line {
  color: #ffffff !important;
}
.default .CodeMirror {
  height: auto !important;
}
.task .CodeMirror {
  height: 100% !important;
  width: 100% !important;
}
.editor{
  border: 1px solid #616161;
  box-sizing: border-box;
}
.CodeMirror-scroll::-webkit-scrollbar {
  background-color: #292A2B;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.CodeMirror-scroll::-webkit-scrollbar {
  background-color: #292A2B;
}
/*定义滚动条轨道 内阴影+圆角*/
.CodeMirror-scroll::-webkit-scrollbar-track {
  background-color: #292A2B;
}
.CodeMirror-scroll::-webkit-scrollbar-thumb {
  background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue